import { render } from "./ItemVariationTable.vue?vue&type=template&id=56c2de8e"
import script from "./ItemVariationTable.vue?vue&type=script&lang=js"
export * from "./ItemVariationTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__